import { styled, css } from 'styled-components';
import { createTransition } from '../../util';
// Dimensions of the switch, in rem
const sizes = {
  inline: {
    knob: 1,
    width: 2,
    height: 1.25,
    stroke: 0.0625
  },
  default: {
    knob: 1.25,
    width: 2.875,
    height: 1.75,
    stroke: 0.125
  },
  centerpiece: {
    knob: 2.25,
    width: 5,
    height: 3,
    stroke: 0.125
  }
};
export const HiddenCheckbox = styled.input.withConfig({
  componentId: "aui__sc-g7p906-0"
})(["position:absolute;opacity:0;pointer-events:none;"]);
export const SwitchElement = styled.span.withConfig({
  componentId: "aui__sc-g7p906-1"
})(["position:relative;cursor:pointer;display:block;", " &:before,&:after{content:'';display:block;border-radius:var(--aui-border-radius-round);", "}", ";"], ({
  $disabled
}) => $disabled && css(["opacity:var(--aui-state-layer-on-disabled);"]), createTransition({
  properties: ['background', 'box-shadow', 'left']
}), ({
  $size,
  $checked
}) => {
  const {
    knob,
    width,
    height,
    stroke
  } = sizes[$size];
  const pad = (height - knob) / 2;
  return css(["&:before{height:", "rem;width:", "rem;background:", ";box-shadow:0 0 0 ", "rem ", " inset;}&:after{position:absolute;top:", "rem;left:", "rem;height:", "rem;width:", "rem;background:", ";}"], height, width, $checked ? 'var(--aui-primary)' : 'var(--aui-neutral-soft)', stroke, $checked ? 'var(--aui-primary)' : 'var(--aui-outline)', pad, $checked ? width - knob - pad : pad, knob, knob, $checked ? 'var(--aui-on-primary)' : 'var(--aui-outline)');
});
export const Label = styled.label.withConfig({
  componentId: "aui__sc-g7p906-2"
})(["display:inline-flex;align-items:center;justify-content:start;flex-direction:", ";gap:var(--aui-spacing-100);cursor:pointer;color:var(--aui-on-surface);&:has(input:focus-visible) ", "{outline:1px solid black;}"], ({
  $labelPosition
}) => $labelPosition === 'left' ? 'row' : 'row-reverse', SwitchElement);